import cn from 'classnames';
import styles from './ProductHeadline.module.scss';

export type ProductHeadlineProps = {
  headline: string;
  class?: string;
};

export default function ProductHeadline({
  headline,
  class: className
}: ProductHeadlineProps) {
  return <p class={cn(styles.headline, className)}>{headline}</p>;
}
